import { Component, EventEmitter, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { provideNativeDateAdapter } from '@angular/material/core';
import { ColComponent, INavData, RowComponent } from '@coreui/angular-pro';
import {
  GlobalDataService,
  ISelectedDataParams,
} from '../../../../services/global-data.service';
import { Subject, takeUntil } from 'rxjs';
import { CommonModule } from '@angular/common';
import { IDepot } from '../../../../models/depart-region-depot.model';

@Component({
  selector: 'app-filter-panel',
  templateUrl: './filter-panel.component.html',
  styleUrls: ['./filter-panel.component.scss'],
  imports: [CommonModule, FormsModule, RowComponent, ColComponent],
  standalone: true,
  providers: [provideNativeDateAdapter()],
})
export class FilterPanelComponent {
  private navItems$ = new Subject<INavData[]>();
  // private selectedFilterValues$ = new Subject<ISelectedDataParams>();
  @Output('selectedFilterValuesEvent') selectedFilterValuesEvent =
    new EventEmitter();
  // Filter options
  dateRanges = [
    { label: 'Today', value: 'TODAY' },
    { label: 'This week', value: 'THIS_WEEK' },
    { label: 'This month', value: 'THIS_MONTH' },
  ];
  // regions = ['All Regions', 'Region 1', 'Region 2', 'Region 3'];
  regions: IDepot[] = [
    {
      id: -1,
      name: 'All',
      icon: '',
      url: '',
      type: 'REGION',
    },
  ];
  depots: IDepot[] = [
    {
      id: -1,
      name: 'All',
      icon: '',
      url: '',
      type: 'DEPOT',
    },
  ]; //['All Depots', 'Depot 1', 'Depot 2', 'Depot 3'];

  vehicleTypes = ['Vehicle Type 1', 'Vehicle Type 2', 'Vehicle Type 3'];
  fuelTypes = ['Fuel Type 1', 'Fuel Type 2', 'Fuel Type 3'];

  // Selected filter options
  selectedDateRange = 'week';
  selectedRegion = 'All Regions';
  selectedDepot = 'All Depots';
  selectedVehicleType = 'Vehicle Type 1';
  selectedFuelType = 'Fuel Type 1';
  // Active Filter (for the badge display)
  get activeFilter(): string {
    return this.selectedDateRange === 'this-year' ? 'This Year' : '';
  }

  // Filter current selections
  selectedFilterValues: ISelectedDataParams = {
    selectedDateStart: null,
    selectedDateEnd: null,
    selectedDateRangeName: 'TODAY',
    selectedDepartment: null,
    selectedRegion: '',
    selectedDepot: '',
    selectedVehicleType: null,
    selectedFuelType: null,
  };

  constructor(private global: GlobalDataService) {}

  ngOnInit() {
    this.global
      .getDepartmentData()
      .pipe(takeUntil(this.navItems$))
      .subscribe({
        next: (data: any) => {
          // this.depots = data.map((element: INavData) => {
          //   return {...element, subElements: element.children?.filter((subElement) => subElement.type === 'DEPOT')}
          // })
          // const flattenedArr = data.flat(2)

          // this.depots = flattenedArr.filter((prop:INavData) => prop?.type === 'DEPOT');

          // for 2 levels
          let flattenedRegionArr: any = [];
          let flattenedDepotArr: any = [];
          for (let i = 0; i < data.length; i++) {
            const item = data[i];

            if (item.children) {
              // loop through children
              //flattenedArr.push(item)
              for (let j = 0; j < item.children.length; j++) {
                const item2 = item.children[j];
                // console.log('flattenedArr item2: ', item2);
                // Get the Regions
                if (item2 && item2.type === 'REGION') {
                  flattenedRegionArr.push(item2);
                }
                if (item2.children) {
                  // loop through children
                  for (let k = 0; k < item2.children.length; k++) {
                    const item3 = item2.children[k];
                    // console.log('flattenedArr item3: ', item3);

                    if (item3 && item3.type === 'DEPOT') {
                      flattenedDepotArr.push(item3);
                    }
                    // if (item3.children) {
                    //    // loop through children
                    //   for (let l = 0; l < item3.children.length; l++) {
                    //     const item4 = item3 .children[l];
                    //     console.log('flattenedArr item4: ', item4);

                    //     // flattenedArr.push(item3)
                    //   }
                    // }
                  }
                }
              }
            }
          }

          this.depots = flattenedDepotArr;
          this.regions = flattenedRegionArr;
        },
      });

    this.global
      .getSelectedDataParams()
      .pipe(takeUntil(this.navItems$))
      .subscribe({
        next: (data: any) => {
          this.selectedFilterValues = data;
        },
      });
  }

  onSelectedFilterValuesChange() {
    this.selectedFilterValuesEvent.emit(this.selectedFilterValues);
  }
}
